/*
 * Developed for G.J. Gardner Homes
 */

import { Injectable } from '@angular/core';

import {  SystemVarsRestService } from '@gh/builder-shared-data';
import { DictionaryService, globalDictionaries } from '@gh/common-shared';

import { Observable } from 'rxjs';


@Injectable()
export class SystemVarsSubscriptionBusinessService {

  constructor(private systemVarsRest: SystemVarsRestService,
              private dictionaryService: DictionaryService
            ) {
}

  initView(): any {
    return {
      states: this.dictionaryService.get(globalDictionaries.states),
    };
  }


  /**
   * Creates Stripe subscription session for customer portal
   * @returns {Observable<{customerPortalSessionUrl: string}>}
   */
}
